import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { ScrollTrigger } from 'gsap/ScrollTrigger'



window.addEventListener('DOMContentLoaded', function() {
    gsap.registerPlugin(ScrollTrigger);
    gsap.registerPlugin(ScrollToPlugin);
    let p = getUrlVars()['p'];
    let scenes = gsap.utils.toArray(".scene");
    let cn = gsap.utils.selector('.wrapper')('.container')[0];
    if(p!= null && p > 0){
       
        //gsap.to(cn, {duration:1,delay:3,scrollTo: {y: (p)*window.innerHeight}});
        gsap.to(cn, {
            scrollTo: { y:scenes[p], autoKill: false },
            duration: 0.5,
            delay:3,
        });
    }
 
    ScrollTrigger.defaults({
        toggleActions: "restart pause resume pause",
        scroller: ".container"
    });

    let article_titles = gsap.utils.toArray(".scene-contaier__inner h2");

    article_titles.forEach((article_title,index)=>{
        gsap.fromTo(article_title, 
            (Math.random()>0.5 ? {autoAlpha:0,x:-30}:{autoAlpha:0,y:-30}),
            {delay:'0.5',duration:'0.5', autoAlpha:1,y:0,x:0,
           scrollTrigger: {
               trigger:article_title
           }},
        );
    });


    let fig_odds = gsap.utils.toArray(".scene .scene-fig:nth-child(odd)");
    let fig_evens = gsap.utils.toArray(".scene .scene-fig:nth-child(even)");
   
    fig_odds.forEach((fig,index)=>{
        gsap.fromTo(fig, 
             (Math.random()>0.5 ? {autoAlpha:0,x:-100}:{autoAlpha:0,y:-100}),
             {delay:'1',duration:'1', autoAlpha:1,x:0,y:0,
            scrollTrigger: {
                trigger:fig
            }},
         );
     });

    fig_evens.forEach((fig,index)=>{
       gsap.fromTo(fig, 
            (Math.random()>0.5 ? {autoAlpha:0,x:100}:{autoAlpha:0,y:100}),
            {delay:'1',duration:'1', autoAlpha:1,x:0,y:0,
            scrollTrigger: {
                trigger:fig
            }},
        );
    });

    let scroll_done = function(index){
        if(index > 0){                    
            setUrlVars([{'name':'p','val':index}])
        }else{
            setUrlVars([])
        }

        return true;
    }

    scenes.forEach((scene,index)=>{
        ScrollTrigger.create({
            trigger: scene,
            scroller: ".container",
            start:"top 100%",
            //end:"+=500",
            //snap:1,
            onEnter:()=>{scroll_done(index)},
            onEnterBack:()=>{scroll_done(index)},
          });
    });

   
    gsap.fromTo(".year_logo", 
        {width:'20%',autoAlpha:0},
        {delay:'1',duration:'1',width:'40%', autoAlpha:1,
        scrollTrigger: {
            trigger: "#s01"
        }},
    );

    //画像右クリック禁止
    let imgs = document.querySelectorAll('img');
    for(let i = 0; i < imgs.length; i++){
        imgs[i].addEventListener("contextmenu", (e)=>{
          e.preventDefault();
        }, false);
    }

    //メニュー
    let menus = document.getElementById('content-index');
    let menu_close_btn = document.getElementById('menu-close-button');
    let menu_cover = document.getElementById('menu-open-cover');
    let menu_item_links = document.querySelectorAll('.content-index-list__item a');
    let menu_item_num = menu_item_links.length;

    for(let i = 0; i < menu_item_num; i++){
        menu_item_links[i].addEventListener('click',(e)=>{
            e.preventDefault();

            menus.classList.remove('open');
            menu_cover.classList.remove('open');
            //menu_cover.removeEventListener('click');
            
            let sid = e.target.getAttribute('href');
            
            scenes.forEach((scn,index)=>{
                if('#'+scn.id == sid){
                    gsap.to(cn, {
                        scrollTo: { y:scenes[index], autoKill: false },
                        duration: 0.5,
                        delay:0
                    });
                } 
            })

            return false;
        });
    }

    menu_close_btn.addEventListener('click',(e)=>{
        e.preventDefault();
        menus.classList.remove('open');
        menu_cover.classList.remove('open');
        menu_cover.removeEventListener('click');
        return false;
    });

    let burger_menu_btn = document.getElementById('burger-menu-button');
    burger_menu_btn.addEventListener('click',(e)=>{
        e.preventDefault();
        menus.classList.add('open');
        menu_cover.classList.add('open');
        menu_cover.addEventListener('click',(ev)=>{
            menus.classList.remove('open');
            menu_cover.classList.remove('open');
        })
        return false;
    });

    let global_footer =  document.getElementById('global-footer');

    // gsap.fromTo(global_footer, 
    //          ({autoAlpha:0,y:100}),
    //          {delay:'1',duration:'1', autoAlpha:1,x:0,y:0,
    //          toggle:'',
    //          scrollTrigger: {
    //              trigger:scenes[scenes.length-1],
    //              onToggle: self => console.log("toggled, isActive:", self.isActive),
    //          }}
    // );

    // ScrollTrigger.create({
    //     trigger:scenes[scenes.length-1],
    //     start: "top top",
    //     endTrigger: "#otherID",
    //     end: "bottom 50%+=100px",
    //     onToggle: self => console.log("toggled, isActive:", self.isActive),
    //     onUpdate: self => {
    //       console.log("progress:", self.progress.toFixed(3), "direction:", self.direction, "velocity", self.getVelocity());
    //     }
    // });
     

    let fadeInTimeline = gsap.timeline({
        scrollTrigger: {
            trigger: scenes[scenes.length-1],
            start: "top 50%",
            toggleActions: "play reverse restart reverse",
        },
    });
    
    let fadeOutTimeline = gsap.timeline({
        scrollTrigger: {
            trigger:scenes[scenes.length-1],
            start: "center 60%",
            end: "top top",
            toggleActions: "play reverse restart reverse",
        },
    });
    
    fadeInTimeline
        .fromTo(
            global_footer,
            { y: 100, autoAlpha: 0 },
            { y: 0, autoAlpha: 1 }
        );
    
    fadeOutTimeline
        .fromTo(
            global_footer,
            { y: 0, autoAlpha: 1 },
            { y: 100, autoAlpha: 0 }
        );


        gsap.fromTo(global_footer, 
        {y:0,autoAlpha:1},
        {delay:'1',y:100, autoAlpha:0,
        scrollTrigger: {
            trigger: "#s01"
        }}
    );
});

function getUrlVars(){
    let vars = [], max = 0, hash = "", array = "";
    let url = window.location.search;
    hash  = url.slice(1).split('&');    
    max = hash.length;
    for (var i = 0; i < max; i++) {
        array = hash[i].split('=');
        vars.push(array[0]);
        vars[array[0]] = array[1];
    }

    return vars;
}

function setUrlVars(params = []){
    let params_length = params.length;
    
    if(params.length <= 0){
        history.replaceState(null,null,window.location.pathname);
        return;
    }
    
    let vars="";

    for(let i=0;i<params_length;i++){
        if(i==0){
            vars += '?'
        }else{
            vars += '&';
        }
        
        vars+=params[i]['name']+"="+params[i]['val'];
    }
    
    history.replaceState(null,null,window.location.pathname+vars);
}